import { c as _c } from "react/compiler-runtime";
import { EntityName } from 'record-it-time-common/EntityName';
import { useEntityRepository } from '../../../hooks/entity/useEntityRepository';
import { useConfigureBreadcrumbsWithBuilder } from '../../../hooks/misc/useConfigureBreadcrumbsWithBuilder';
export function useConfigureCreateWorkTimeEntrySelectActivityPageBreadcrumbs(parentActivityId) {
  const $ = _c(3);
  const timeTrackingActivityRepository = useEntityRepository(EntityName.TimeTrackingActivity);
  let t0;
  if ($[0] !== parentActivityId || $[1] !== timeTrackingActivityRepository) {
    t0 = builder => {
      builder.addHomePage().addCreateWorkTimeEntryPage().addCreateWorkTimeEntrySelectActivityPage(null);
      const path = parentActivityId ? timeTrackingActivityRepository.getPath(parentActivityId) : [];
      for (const activity of path) {
        if (activity) {
          builder.addCreateWorkTimeEntrySelectActivityPage(activity.id);
        }
      }
    };
    $[0] = parentActivityId;
    $[1] = timeTrackingActivityRepository;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  useConfigureBreadcrumbsWithBuilder(t0);
}